// Настройки карточки продукта.

export const configProduct = {
  minPriceShopTwoHours: 5_000,
};
